/* Manuka theme — minimal interactions, no dependencies. */
(function () {
  'use strict';

  // Mobile navigation toggle
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-nav-toggle]');
    if (!toggle) return;
    var nav = document.querySelector('[data-mobile-nav]');
    if (!nav) return;
    var open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  // Product gallery thumbnails
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-thumb]');
    if (!thumb) return;
    var main = document.querySelector('[data-product-main-image]');
    if (!main) return;
    main.src = thumb.dataset.thumb;
    main.srcset = '';
  });

  // Variant selection: keep the URL, price and buy button in sync.
  document.querySelectorAll('[data-variant-form]').forEach(function (form) {
    var data = document.querySelector('[data-variant-json="' + form.dataset.variantForm + '"]');
    if (!data) return;

    var variants;
    try {
      variants = JSON.parse(data.textContent);
    } catch (error) {
      return;
    }

    var selects = form.querySelectorAll('[data-option-index]');
    if (!selects.length) return;

    function update() {
      var chosen = Array.prototype.map.call(selects, function (select) {
        return select.value;
      });

      var match = variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return option === chosen[index];
        });
      });

      var idInput = form.querySelector('[data-variant-id]');
      var button = form.querySelector('[data-add-button]');
      var priceEl = document.querySelector('[data-variant-price]');

      if (!match) {
        if (button) {
          button.disabled = true;
          button.textContent = button.dataset.unavailable || 'UNAVAILABLE';
        }
        return;
      }

      if (idInput) idInput.value = match.id;

      if (button) {
        button.disabled = !match.available;
        button.textContent = match.available
          ? (button.dataset.available || 'ADD TO BAG')
          : (button.dataset.soldOut || 'SOLD OUT');
      }

      if (priceEl && match.price_formatted) {
        priceEl.innerHTML = match.compare_at_price_formatted
          ? '<s>' + match.compare_at_price_formatted + '</s>' + match.price_formatted
          : match.price_formatted;
      }

      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    selects.forEach(function (select) {
      select.addEventListener('change', update);
    });
    update();
  });
})();
